import {
  USERNAME_MAX_LENGTH,
  USERNAME_MIN_LENGTH,
} from "@/models/auth/AuthenticatedUser";

/**
 * Some helpers concerning users
 */
export class UserHelper {
  /**
   * Check if string is a valid username
   * @param username
   * @param existingUsernames an array of existing usernames
   */
  static isValidUsername(
    username: string | null,
    existingUsernames: string[] = []
  ): null | boolean {
    if (username === "" || username === null) {
      return null;
    }
    return (
      UserHelper.isAlphaNumeric(username) &&
      username.length >= USERNAME_MIN_LENGTH &&
      username.length <= USERNAME_MAX_LENGTH &&
      !existingUsernames?.includes(username)
    );
  }

  /**
   * check if a string is alpha numeric
   */
  private static isAlphaNumeric(candidate: string): boolean {
    const regEx = /^[0-9a-zA-Z]+$/;
    return !!candidate.match(regEx);
  }
}
